import type { useApiFetch } from '@/features/auth'
import type { Me, MeStats } from '@/features/session/types'

type AuthedFetch = ReturnType<typeof useApiFetch>

export function fetchMe(authedFetch: AuthedFetch): Promise<Me> {
  return authedFetch<Me>('/api/v1/me')
}

export function fetchMeStats(authedFetch: AuthedFetch): Promise<MeStats> {
  return authedFetch<MeStats>('/api/v1/me/stats')
}

/** `PATCH /me/phone` — the self-service counterpart to the admin-settable `phone` on Add/Edit
 * Staff. 204 No Content on success. */
export function updateMyPhone(authedFetch: AuthedFetch, phone: string): Promise<void> {
  return authedFetch<void>('/api/v1/me/phone', {
    method: 'PATCH',
    body: JSON.stringify({ phone }),
  })
}
